import { createContext, useState } from "react";

export const ExerciseContext = createContext();

export const ExerciseProvider = ({ children }) => {
    // Seznam pro 8 vybraných cviků (začínáme s prázdným seznamem)
    const [selectedExercises, setSelectedExercises] = useState(Array(8).fill(null));

    return (
        <ExerciseContext.Provider value={{ selectedExercises, setSelectedExercises }}>
            {children}
        </ExerciseContext.Provider>
    );
};
